exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-icon[data-v-2162b0b1] {\n  background: #2b93ff !important;\n}\n", ""]);

// exports
